import React, { useState } from 'react';
import { Shield, HeartHandshake, LifeBuoy, ChevronRight } from 'lucide-react';
import { BonusModal } from './BonusModal';
const bonusesData = [{
  id: 1,
  icon: Shield,
  title: 'Kit Noche Blindada',
  subtitle: 'Setup Anti-Ruido en 10 Min',
  shortDesc: 'Convierte tu apartamento ruidoso en una burbuja de sueño.',
  image: 'https://cdn.magicpatterns.com/uploads/anNqFT7kTfJ2LbxSrP3dvM/portada_bono_1.png',
  details: ['Mapa de Ruido para detectar y neutralizar', 'Setup anti-ruido en 10 minutos', 'Checklist imprimible', 'Plan B para noches imposibles'],
  footer: 'Diseñado para Bogotá, Medellín, Cali y más.'
}, {
  id: 2,
  icon: HeartHandshake,
  title: 'Paz en Pareja',
  subtitle: 'Turnos Sin Pelea',
  shortDesc: 'Dejen de discutir a las 2 AM con un guión de 7 minutos.',
  image: 'https://cdn.magicpatterns.com/uploads/fbsPBFmS4n8uKR65zAxxin/portada_bono_2.png',
  details: ['Guión para coordinarse antes de dormir', 'Plantillas de turnos listas', 'Scripts para pedir ayuda sin reproche', 'Protocolo anti-resentimiento'],
  footer: 'Porque el cansancio también afecta la relación.'
}, {
  id: 3,
  icon: LifeBuoy,
  title: 'SOS 3:15 AM',
  subtitle: 'Tarjetas de Decisión Rápida',
  shortDesc: 'Sabé exactamente qué hacer en 30 segundos.',
  image: 'https://cdn.magicpatterns.com/uploads/fsdM1qDVButRK2iLpvi8aH/portada_bono_3.png',
  details: ['Árbol de decisión (6 escenarios)', 'Tarjetas por causa específica', 'Tracker de 7 noches', 'Casos resueltos colombianos'],
  footer: 'El bono más usado a las 3 AM.'
}];
export function BonusSection() {
  const [selectedBonus, setSelectedBonus] = useState<(typeof bonusesData)[0] | null>(null);
  return <section className="py-12 md:py-16 bg-warm-200" data-id="element-49">
      <div className="max-w-5xl mx-auto px-4" data-id="element-50">
        <div className="text-center mb-10" data-id="element-51">
          <h2 className="text-2xl md:text-3xl font-bold text-text-dark mb-2" data-id="element-52">
            + 3 Bonos de Implementación
          </h2>
          <p className="text-text-muted" data-id="element-53">
            Herramientas para aplicar desde el día 1
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5" data-id="element-54">
          {bonusesData.map(bonus => {
          const Icon = bonus.icon;
          return <div key={bonus.id} className="bg-white rounded-2xl shadow-sm overflow-hidden flex flex-col" data-id="element-55">
                <div className="bg-gradient-to-br from-primary-700 to-primary-600 h-52 md:h-56 p-4 flex items-center justify-center" data-id="element-56">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-full object-contain drop-shadow-xl" data-id="element-57" />
                </div>
                <div className="p-5 flex flex-col flex-1" data-id="element-58">
                  <div className="flex items-center gap-2 mb-3" data-id="element-59">
                    <Icon className="w-4 h-4 text-primary-500" data-id="element-60" />
                    <span className="text-xs font-semibold text-primary-500 uppercase tracking-wide" data-id="element-61">
                      Bono #{bonus.id}
                    </span>
                  </div>
                  <h3 className="font-bold text-text-dark text-lg mb-2" data-id="element-62">
                    {bonus.title}
                  </h3>
                  <p className="text-sm text-text-muted mb-4 flex-1" data-id="element-63">
                    {bonus.shortDesc}
                  </p>
                  <button onClick={() => setSelectedBonus(bonus)} className="flex items-center gap-1 text-sm text-primary-600 font-medium hover:text-primary-700 transition-colors w-fit" data-id="element-64">
                    Leer más <ChevronRight className="w-4 h-4" data-id="element-65" />
                  </button>
                </div>
              </div>;
        })}
        </div>
      </div>

      <BonusModal isOpen={!!selectedBonus} onClose={() => setSelectedBonus(null)} bonus={selectedBonus} data-id="element-66" />
    </section>;
}